import "babel-polyfill";
import Vue from "vue";
import i18n from './i18n';
import App from "./App.vue";
import router from './router'
import xss from './assets/js/xss';
import ElementUI from "element-ui";
import ElementLocale from 'element-ui/lib/locale' // element-ui国际化
import Resource from "vue-resource";
import store from "./store/store.js";
import utls from "./assets/js/utls.js";
import Base64 from "./assets/js/base64.js"; // 用于query传参加密
import common from "./assets/js/common.js"; // 公共js
import echarts from 'echarts'
import moment from 'moment';
import Components from './components';
import directive from './directive/index'; //全局指令
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/element-variables.scss";
import "./assets/css/common.css";
import './assets/js/lang';  // 用于后台数据国际化
import "./utils/filter"
import { preventReClick } from './components/layer/studentJob/preventReClick';
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.prototype.$echarts = echarts;
Vue.prototype.$Base64 = Base64;
// bus传值
Vue.prototype.bus = new Vue();
// 按钮节流
Vue.prototype.$preventReClick = preventReClick;
// 不允许点击遮罩层关闭弹窗
Vue.prototype.baseURL = "/cat"; // HTML 中路径的前缀
Vue.prototype.$platformType = Number(VUE_APP_PLATFORMTYPE);
Vue.prototype.xss = xss;
Vue.prototype.$moment = moment;

ElementLocale.i18n((key, value) => i18n.t(key, value));
ElementUI.Dialog.props.closeOnClickModal.default = false;

Vue.use(common);
Vue.use(Resource); //使用resource
Vue.use(utls);
Vue.use(ElementUI);
Vue.use(Components);
Vue.use(directive);

Vue.config.productionTip = false;
moment.locale('zh-cn');

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
